import { render, staticRenderFns } from "./BestCandidate.vue?vue&type=template&id=47561b1e"
import script from "./BestCandidate.vue?vue&type=script&lang=ts"
export * from "./BestCandidate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports